module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_gold_de-032b75283b9a2b4924f98ef7e6b26ff5.png";